<script>
  import { zeroPadding } from '@/mixins/common'
  import pageScroll from '@/mixins/page-scroll';

  const ENABLED_CLICK_IDS = [0, 1, 2, 4, 9, 14, 19];

  export default {
    name: 'SugorokuCircle',
    props: {
      x: {
        type: Number,
        default: 0
      },
      y: {
        type: Number,
        default: 0
      },
      w: {
        type: Number,
        default: 0
      },
      h: {
        type: Number,
        default: 0
      },
      i: {
        type: Number,
        default: 0
      }
    },
    computed: {
      n() {
        return this.$store.state.answeredIds.length;
      },
      getImageStr() {
        if (this.i === this.n) {
          return 'current';
        } else if (this.n > this.i) {
          return 'stamp';
        } else {
          return 'normal';
        }
      },
      getImageStrCurrent() {
        if (this.i === 19) {
          return 'end';
        } else if (this.i === 1 || this.i === 2) {
          return 's';
        } else if (ENABLED_CLICK_IDS.indexOf(this.i) > -1) {
          return 'l';
        } else {
          return 'common';
        }
      },
      styles() {
        const img = require(`@/assets/img/frame${zeroPadding(this.i + 1, 2)}_${this.getImageStr}.png`);

        return {
          width: `${this.w / 375 * 100}%`,
          height: `${this.h / 362 * 100}%`,
          top: `${this.y / 362 * 100}%`,
          left: `${this.x / 375 * 100}%`,
          cursor: ((ENABLED_CLICK_IDS.indexOf(this.i) > -1) ||  this.n === this.i) ? 'pointer' : 'auto',
          pointerEvents: (this.n >= this.i) ? 'auto' : 'none',
          backgroundImage: `url(${img})`,
        }
      },
      stylesCurrent() {
        const img = require(`@/assets/img/current_${this.getImageStrCurrent}.png`);
        return {
          display: (this.n === this.i) ? 'block' : 'none',
          backgroundImage: `url(${img})`,
        }
      }
    },
    methods: {
      click(e) {
        if(this.n === this.i) {
          const element = document.getElementById("top");
          const y = window.pageYOffset;
          const top = element.getBoundingClientRect().top;
          pageScroll(y, top + y);
        }
        if (this.n <= this.i) return;
        this.$emit('click', e);
      },
    }
  }
</script>

<template lang="pug">
  .sugoroku-circle(
    :style = 'styles'
    key = 'key'
    @click = 'click'
    )
    .sugoroku-circle__current(
      :style = 'stylesCurrent'
      key = "`${key}_c`"
      )
</template>

<style lang="scss">
  .sugoroku-circle {
    position: absolute;
    z-index: 10;
    -webkit-background-size: cover;
    background-size: 100% 100%;
    &__current {
      position: relative;
      z-index: 10;
      width: 100%;
      height: 100%;
      -webkit-background-size: cover;
      background-size: 100% 100%;
      pointer-events: none;
    }
    //
    // 点滅アニメーション
    &__current {
      animation: blink 2s infinite ease;
    }
  }
</style>
